<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查方案详情
      </div>
    </div>
    <div class="common-page common-body">
      <el-steps :active="type" finish-status="success">
        <el-step title="方案提报" :description="'提报时间：' + programmeInfo.wenwuInspectionAppScheme.createTime"></el-step>
        <el-step
          title="方案设计"
          :class="programmeInfo.wenwuInspectionAppScheme.examineState == 2 ? 'red' : ''"
          :description="
            type > 1
              ? '方案最新提交时间：' + programmeInfo.wenwuInspectionAppScheme.designTime
              : programmeInfo.wenwuInspectionAppScheme.examineState == 2
              ? '上次驳回原因：' +
                (programmeInfo.wenwuInspectionAppScheme.designReason || '') +
                '\n' +
                ' 驳回时间：' +
                (programmeInfo.wenwuInspectionAppScheme.designTime || '')
              : ''
          "
        ></el-step>
        <el-step title="方案审批" :description="type > 2 ? '方案审批通过时间：' + programmeInfo.wenwuInspectionAppScheme.approvalTime : ''"></el-step>
        <el-step
          :class="programmeInfo.wenwuInspectionAppScheme.evaluation == 2 ? 'red' : ''"
          title="方案施工"
          :description="
            type > 3
              ? '方案施工内容上传时间：' + programmeInfo.wenwuInspectionAppScheme.constructionTime
              : programmeInfo.wenwuInspectionAppScheme.evaluation == 2
              ? '上次驳回原因：' +
                (programmeInfo.wenwuInspectionAppScheme.constructionReason || '') +
                '\n' +
                ' 驳回时间：' +
                (programmeInfo.wenwuInspectionAppScheme.constructionTime || '')
              : ''
          "
        ></el-step>
        <el-step title="方案评价" :description="type > 4 ? '方案评价时间：' + programmeInfo.wenwuInspectionAppScheme.evaluateTime : ''"></el-step>
      </el-steps>
      <div><strong>隐患详情</strong></div>
      <el-collapse v-for="(programme, index) of programmeInfo.middleInSchemeList" v-model="collapse">
        <el-collapse-item :title="'隐患' + (programme.serialNo || '')" :name="index + 1">
          <div>
            <div class="disease">
              <div class="header"><span class="blue-box"></span>基本信息<el-divider></el-divider></div>
              <div class="body plant">
                <div v-for="(item, key) in essentialInformation" class="">
                  <span class="vertical-center"
                    ><span style="width: 100px;">{{ essentialInformation[key] }}</span> {{ programme[key] }}</span
                  >
                </div>
              </div>
            </div>
            <div class="disease">
              <div class="header"><span class="blue-box"></span>{{ programme.checkSmall }}<el-divider></el-divider></div>
              <div class="body">
                <div class="flex vertical-center">
                  <span class="label">结果：</span>
                  <el-radio-group class="vertical-center1" :value="!programme.abnormal" disabled>
                    <el-radio :label="true">正常</el-radio>
                    <el-radio :label="false">异常</el-radio>
                  </el-radio-group>
                </div>
                <div class="flex vertical-center">
                  <div class="label">位置：</div>
                  {{ programme.location }}
                  <!-- <el-input class="val" placeholder="请输入内容" :value="input" :disabled="true"> </el-input> -->
                </div>
                <div class="flex vertical-center">
                  <div class="label">巡查数据：</div>
                  {{ programme.patrolData }}
                  <!-- <el-input class="val" placeholder="请输入内容" :value="input" :disabled="true"> </el-input> -->
                </div>
              </div>
            </div>
            <div class="disease">
              <div class="header">
                <span class="blue-box"></span>巡查图片
                <el-divider></el-divider>
              </div>
              <div class="img-group flex">
                <div v-for="(pic, idx) of programme.childList">
                  <div class="vertical-center">
                    <strong>照片编号：{{ pic.photoNum }}</strong>
                  </div>
                  <div>
                    <el-image v-if="pic.photoUrl" @click="openPicDia(pic)" class="img" :src="pic.photoUrl" :fit="'contain'"></el-image>
                  </div>
                </div>
              </div>
            </div>
            <div class="disease">
              <div class="header">
                <span class="blue-box"></span>方案设计
                <el-divider></el-divider>
              </div>
              <div class="body" style="grid-auto-rows: auto;">
                <div class="flex vertical-center">
                  <div class="label">方案批注：</div>
                  <el-input class="val" :disabled="type !== 1" placeholder="请输入内容" v-model="programme.schemeAnnotation" />
                </div>
                <div class="flex vertical-center" style="align-items: flex-start;">
                  <div class="label">相关资料：</div>
                  <fileUpload
                    :disabled="type !== 1"
                    v-model="programme.relevantInformation"
                    :uploadData="{ flagType: '0' }"
                    :fileType="['pdf', 'jpg', 'png', 'word', 'excel']"
                    :fileUrl="'/oss/file/uploadFileFlag'"
                    :limit="5"
                    :fileSize="10"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div v-if="type >= 1"><strong>方案设计</strong></div>
      <div v-if="type >= 1" class="merge-content">
        <div class="flex vertical-center">
          <div class="label">方案简介：<span class="red">*</span></div>
          <el-input class="val" :disabled="type !== 1" placeholder="请输入内容" v-model="programmeInfo.wenwuInspectionAppScheme.schemeIntroduction"> </el-input>
        </div>
        <div class="flex">
          <div class="label">方案资料：<span class="red">*</span></div>
          <fileUpload
            :disabled="type !== 1"
            v-model="programmeInfo.wenwuInspectionAppScheme.schemeInformation"
            :uploadData="{ flagType: '0' }"
            :fileType="['pdf', 'jpg', 'png', 'word', 'excel']"
            :fileUrl="'/oss/file/uploadFileFlag'"
            :limit="5"
            :fileSize="10"
          />
        </div>
      </div>
      <div v-if="type >= 3"><strong>方案施工</strong></div>
      <div v-if="type >= 3" class="merge-content">
        <div class="flex vertical-center">
          <div style="width: 50%;">
            <div class="mb12"><strong>施工前照片</strong><span class="red">*</span></div>
            <fileUpload
              :disabled="type !== 3"
              v-model="programmeInfo.wenwuInspectionAppScheme.constructionBeforePhoto"
              :uploadData="{ flagType: '0' }"
              :fileType="['jpg', 'png']"
              :fileUrl="'/oss/file/uploadFileFlag'"
              :limit="5"
              :fileSize="10"
            />
          </div>
          <div style="width: 50%;">
            <div class="mb12"><strong>施工后照片</strong> <span class="red">*</span></div>
            <fileUpload
              :disabled="type !== 3"
              v-model="programmeInfo.wenwuInspectionAppScheme.constructionAfterPhoto"
              :uploadData="{ flagType: '0' }"
              :fileType="['jpg', 'png']"
              :fileUrl="'/oss/file/uploadFileFlag'"
              :limit="5"
              :fileSize="10"
            />
          </div>
        </div>
        <div class="flex">
          <div class="label">施工备注：</div>
          <el-input :disabled="type !== 3" v-model="programmeInfo.wenwuInspectionAppScheme.constructionRemark"></el-input>
        </div>
      </div>
      <div v-if="type >= 4"><strong>方案验收</strong></div>
      <div v-if="type >= 4" class="merge-content">
        <div class="flex vertical-center">
          <div class="label">验收评价：</div>
          <el-radio-group :disabled="type !== 4" v-model="programmeInfo.wenwuInspectionAppScheme.evaluation" size="medium">
            <el-radio-button label="1">合格</el-radio-button>
            <el-radio-button label="2">不合格</el-radio-button>
          </el-radio-group>
        </div>
        <div class="flex">
          <div class="label">验收备注：</div>
          <el-input
            :disabled="type !== 4"
            type="textarea"
            v-model="programmeInfo.wenwuInspectionAppScheme.evaluationRemark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
          >
          </el-input>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="submitDiaInfo.isShow" width="60%">
      <div class="title" style="border-left: none">{{ submitDiaInfo.title }}</div>
      <div class="title" v-if="submitDiaInfo.errorMessage" style="border-left: none">{{ submitDiaInfo.errorMessage }} <span class="red">*</span></div>
      <div class="title" v-if="submitDiaInfo.errorMessage" style="border-left: none">
        <el-input v-model="submitDiaInfo.errorReason"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 认</el-button>
        <el-button @click="submitDiaInfo.isShow = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="signDia" width="60%">
      <sign @confirm="signImg"></sign>
    </el-dialog>
    <el-dialog title="图片详情" :visible.sync="pubilcImgDia" width="60%">
      <div class="flex img-dia">
        <el-image style="width:50%" :src="pubilcImgInfo.photoUrl" :fit="'contain'"></el-image>
        <!-- {{ pubilcImgInfo }} -->
        <div class="img-dia-table">
          <div>
            <strong>照片编号：{{ pubilcImgInfo.photoNum }}</strong>
          </div>
          <div>拍摄时间：{{ pubilcImgInfo.photoTime }}</div>
          <div>拍摄位置：{{ pubilcImgInfo.photoLocation }}</div>
          <div>
            拍摄内容：
            <el-input disabled v-model="pubilcImgInfo.photoContent"></el-input>
          </div>
          <div>
            文字描述：
            <el-input disabled v-model="pubilcImgInfo.photoDescribe"></el-input>
          </div>
          <div>
            备注：
            <el-input disabled v-model="pubilcImgInfo.remark"></el-input>
          </div>
          <div>
            <el-button type="primary" @click="pubilcImgDia = false">关 闭</el-button>
          </div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer"> -->
      <!-- <el-button @click="pubilcImgDia = false">取 消</el-button> -->
      <!-- <el-button type="primary" @click="pubilcImgDia = false">关 闭</el-button> -->
      <!-- </span> -->
    </el-dialog>
    <el-backtop target=".common-body-style"></el-backtop>
    <div class="btn-box center">
      <el-button type="primary" class="ml20" @click="$router.back()">返回</el-button>
      <el-button
        type="primary"
        class="ml20"
        v-if="$store.state.user.roles[0] == 'wenwu_approver' ? type == 2 || type == 4 : type != 5"
        v-hasPermi="['culturalRelics:wenwuInspectionAppScheme:click']"
        @click="submit"
        >提交</el-button
      >
      <el-button
        type="primary"
        v-if="$store.state.user.roles[0] == 'wenwu_approver' ? type == 2 : type == 2"
        v-hasPermi="['culturalRelics:wenwuInspectionAppScheme:click']"
        class="ml20"
        @click="reject"
        >驳回</el-button
      >
    </div>
  </div>
</template>

<script>
import sign from "./component/sign.vue";
export default {
  components: { sign },
  data() {
    return {
      essentialInformation: {
        builderName: "文物建筑名称：",
        inspectionMethod: "巡查方法：",
        nickName: "巡查人：",
        inspectionScope: "巡查范围：",
        roadNameDoorplate: "路名门牌：",
        inspectionDate: "巡查日期：",
        extremeWeatherRecord: "极端天气记录：",
      },
      id: this.$route.query.id || "",
      programmeInfo: { wenwuInspectionAppScheme: {}, middleInSchemeList: [] },
      type: 1,
      pubilcImgDia: false,
      signDia: false,
      params: { click: 1, id: this.$route.query.id },
      pubilcImgInfo: "",
      submitDiaInfo: { isShow: false, title: "", errorMessage: "", errorReason: "" },
      submitDiaType: {
        1: { title: "确认提交方案吗?", errorMessage: "", errorReason: "" },
        2: { title: "确认通过该施工方案吗?", errorMessage: "", errorReason: "" },
        3: { title: "确认提交施工详情吗?", errorMessage: "", errorReason: "" },
        4: { title: "确认该方案合格吗?", errorMessage: "", errorReason: "" },
        4: { title: "确认该方案合格吗?", errorMessage: "", errorReason: "" },
      },
      rejectDiaType: {
        2: { title: "确认驳回该施工方案吗?", errorMessage: "请填写驳回原因", errorReason: "" },
        4: { title: "确认该方案不合格吗?", errorMessage: "请填写整改原因", errorReason: "" },
      },
      collapse: [1, 2],
    };
  },
  watch: {
    collapse: {
      handler(newVal, oldVal) {
        if (newVal.length > 2) {
          newVal.shift();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$get("/culturalRelics/wenwuInspectionAppScheme/" + this.id)
        .then((res) => {
          console.log(res);
          this.programmeInfo = res.data;
          this.type = this.programmeInfo.wenwuInspectionAppScheme.state;
        })
        .catch((error) => {
          this.$router.back();
        });
    },
    openPicDia(pic) {
      this.pubilcImgDia = true;
      this.pubilcImgInfo = pic;
    },
    confirm() {
      switch (this.type) {
        case 1:
          this.signDia = true;
          this.submitDiaInfo.isShow = false;
          break;
        case 2:
          if (this.submitDiaInfo.errorMessage) {
            this.params.click = 2;
            if (!this.submitDiaInfo.errorReason) {
              this.$message({
                type: "error",
                message: "请补充驳回原因!",
              });
              return;
            } else {
              this.params.designReason = this.submitDiaInfo.errorReason;
            }
          } else this.params.click = 1;
          this.signDia = true;
          this.submitDiaInfo.isShow = false;
          break;
        case 3:
          this.signDia = true;
          this.submitDiaInfo.isShow = false;
          break;
        case 4:
          if (this.submitDiaInfo.errorMessage) {
            this.params.evaluation = 2;
            if (!this.submitDiaInfo.errorReason) {
              this.$message({
                type: "error",
                message: "请补充驳回原因!",
              });
              return;
            } else {
              this.params.designReason = this.submitDiaInfo.errorReason;
            }
          } else this.params.evaluation = 1;
          this.params.evaluationRemark = this.programmeInfo.wenwuInspectionAppScheme.evaluationRemark;
          this.signDia = true;
          this.submitDiaInfo.isShow = false;
          break;
        default:
          break;
      }
    },
    signImg(e) {
      console.log(e.file);
      // e, typeof e, , e.file
      let formData = new FormData();
      formData.append("file", e.file);
      // let a=formData.get('file')
      // console.log(a,11111);

      this.$post("/oss/file/uploadFileFlag", formData)
        .then((res) => {
          // console.log(res,1111);
          switch (this.type) {
            case 1:
              this.programmeInfo.wenwuInspectionAppScheme.designSignUrl = res.data.url;
              this.$put("/culturalRelics/wenwuInspectionAppScheme/designEdit", this.programmeInfo).then((res) => {
                // console.log(res);
                this.signDia = false;
                this.$router.back();
              });
              break;
            case 2:
              this.params.signUrl = res.data.url;
              // this.params.designReason = this.params.reason;
              this.$put("/culturalRelics/wenwuInspectionAppScheme/click", this.params).then((res) => {
                // this.params.reason = this.submitDiaInfo.errorReason;
                this.$router.back();
                console.log(res);
              });
              break;
            case 3:
              this.programmeInfo.wenwuInspectionAppScheme.constructionSignUrl = res.data.url;
              this.$put("/culturalRelics/wenwuInspectionAppScheme/constructionEdit", this.programmeInfo.wenwuInspectionAppScheme).then((res) => {
                // console.log(res);
                this.signDia = false;
                this.$router.back();
              });
              break;
            case 4:
              this.params.signUrl = res.data.url;
              this.params.constructionReason = this.params.designReason;
              this.params.designReason = "";
              this.$put("/culturalRelics/wenwuInspectionAppScheme/acceptanceEvaluationEdit", this.params).then((res) => {
                //  = this.submitDiaInfo.errorReason;
                this.$router.back();
                console.log(res);
              });
              // this.params.reason = this.params.reason;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submit() {
      this.params = { click: 1, id: this.$route.query.id };
      if (
        this.type == 1 &&
        (!this.programmeInfo.wenwuInspectionAppScheme.schemeIntroduction || !this.programmeInfo.wenwuInspectionAppScheme.schemeInformation)
      ) {
        this.$message({
          type: "error",
          message: "请完成方案设计!",
        });
        return;
      }
      if (
        this.type == 3 &&
        (!this.programmeInfo.wenwuInspectionAppScheme.constructionBeforePhoto || !this.programmeInfo.wenwuInspectionAppScheme.constructionAfterPhoto)
      ) {
        this.$message({
          type: "error",
          message: "请上传施工前、后照片!",
        });
        return;
      }

      // !this.programmeInfo.wenwuInspectionAppScheme.evaluationRemark;
      if (this.type == 4) {
        if (this.programmeInfo.wenwuInspectionAppScheme.evaluation == 2) {
          this.reject();
          return;
        } else if (this.programmeInfo.wenwuInspectionAppScheme.evaluation == 0) {
          this.$message({
            type: "error",
            message: "请选择验收状态",
          });
          return;
        }
      }
      this.submitDiaInfo = Object.assign(this.submitDiaInfo, this.submitDiaType[this.type]);
      this.submitDiaInfo.isShow = true;
    },
    reject() {
      this.params = { click: 1, id: this.$route.query.id };
      this.submitDiaInfo = Object.assign(this.submitDiaInfo, this.rejectDiaType[this.type]);
      this.submitDiaInfo.isShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.common-body {
  text-align: left;
  padding: 0 48px;
  height: calc(100% - 59px);
}

.blue-box {
  background-color: rgba(39, 123, 249, 1);
  width: 6px;
  height: 18px;
  border-radius: 8px;
  display: inline-block;
  margin-right: 12px;
}
.vertical-center {
  display: flex;
  align-items: center;
}
.vertical-center1 {
  display: flex;
  align-items: center;
}
.merge-content {
  padding-left: 60px;
  display: flex;
  flex-direction: column;
  grid-template-columns: 100%;
  grid-auto-rows: 32px;
  grid-gap: 12px;
  .label {
    flex-shrink: 0;
    width: 120px;
  }
  .val {
    height: 100%;
  }
  .mb12 {
    margin-bottom: 12px;
  }
}
.disease {
  // background-color: #f8f8f8;
  // border: #666 1px solid;
  border-radius: 8px;
  padding: 0 12px;
  margin: 0 12px;
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 12px;
  .header {
    display: flex;
    align-items: center;
  }
  .body {
    display: grid;
    grid-gap: 6px;
    grid-auto-rows: 24px;
  }
  .img-group {
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
    justify-items: center;
    .vertical-center {
      margin-left: 0;
    }
    .img {
      max-width: 100%;
    }
  }
  .plant {
    grid-template-columns: 33.3% 33.3% 33.3%;
  }
  .vertical-center {
    margin-left: 60px;
    // display: flex;
    // align-items: center;
  }
  .label {
    flex-shrink: 0;
    width: 200px;
  }
  .val {
    width: calc(100% - 200px);
  }
  .img {
    border-radius: 8px;
    min-width: 200px;
    max-width: calc(100% - 200px);
    height: 100%;
  }
  .pic-box {
    width: 100%;
    border: 1px solid #666;
  }
  ::v-deep .el-input__inner {
    // height: 100%;
  }
}
.btn-box {
  margin: 0;
  padding-bottom: 20px;
}
.el-divider--horizontal {
  flex: 1;
  margin: 12px 0 12px 24px;
  display: inline-block;
  background-color: #666;
  background-image: linear-gradient(to right, #666 50%, #666 50%);
  background-position: top;
  background-size: 20px 1px;
  background-repeat: repeat-x;
}
.el-collapse {
  border: 1px solid #ebeef5;
  // border-bottom: 1px solid #EBEEF5;
  ::v-deep .el-collapse-item__header {
    padding-left: 12px;
    background-color: rgba(217, 217, 217, 1);
  }
}

::v-deep .el-dialog:not(.is-fullscreen) {
  margin-top: 15vh !important;
}
::v-deep .el-step__description {
  transform: scale(0.8);
  transform-origin: 0 0;
}
.img-dia {
  img {
    flex: 1;
    min-width: 50%;
  }
  .img-dia-table {
    margin-left: 12px;
    display: grid;
    grid-gap: 6px;
    ::v-deep .el-button {
      float: right;
    }
  }
}
.upload-file-uploader {
  margin: 0;
  display: flex;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
::v-deep .red .el-step__description {
  color: red;
  white-space: pre-line;
}
</style>
